import dayjs from '@/services/date/index'
import { isNullOrEmptyArray } from '@/helpers/array-helpers'
import BookingClientViewModel from './bookingClientViewModel'
import BookingClientGroupViewModel from './bookingClientGroupViewModel'
import BookingCreatedByViewModel from './bookingCreatedByViewModel'
import BookingLocationViewModel from './bookingLocationViewModel'
import BookingDetailsViewModel from './bookingDetailsViewModel'
import BookingDateViewModel from './bookingDateViewModel'

export default class BookingViewModel {
  constructor(params) {
    this.id = params.id
    this.status = params.status
    this.createdBy = params.createdBy
      ? new BookingCreatedByViewModel(params.createdBy)
      : null
    this.createdOnUtc = params.createdOnUtc ? dayjs(params.createdOnUtc) : null
    this.client = params.client
      ? new BookingClientViewModel(params.client)
      : null
    this.clientGroup = params.clientGroup
      ? new BookingClientGroupViewModel(params.clientGroup)
      : null
    this.location = params.location
      ? new BookingLocationViewModel(params.location)
      : null
    this.details = params.details
      ? new BookingDetailsViewModel(params.details)
      : null
    this.dates = !isNullOrEmptyArray(params.dates)
      ? params.dates.map((date) => new BookingDateViewModel(date))
      : []
  }
}
